var getUserAgent = function () {
    try {
        return window.navigator.userAgent;
    }
    catch (e) {
        return '';
    }
};
var agentIdentities = function () {
    var userAgent = getUserAgent();
    return {
        Safari: userAgent.includes('Safari'),
        Chrome: userAgent.includes('Chrome'),
        Chromium: userAgent.includes('Chromium'),
        CriOS: userAgent.includes('CriOS'),
        FxiOS: userAgent.includes('FxiOS'),
        Edge: userAgent.includes('Edg'),
        Opera: userAgent.includes('OP'),
    };
};
var isIpadPlatform = function () {
    try {
        // @ts-expect-error
        return window.navigator.platform === 'MacIntel' && typeof window.navigator.standalone !== 'undefined';
    }
    catch (_a) {
        return false;
    }
};
export var isSafari = function () {
    var _a = agentIdentities(), Safari = _a.Safari, Chrome = _a.Chrome, CriOS = _a.CriOS, FxiOS = _a.FxiOS;
    return Safari && !Chrome && !CriOS && !FxiOS;
};
export var isChromium = function () {
    var _a = agentIdentities(), Chrome = _a.Chrome, Chromium = _a.Chromium;
    return Chrome || Chromium;
};
export var getChromiumVersion = function () {
    var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
    return raw ? parseInt(raw[2], 10) : null;
};
export var isUnsupportedBrowser = function () {
    if (isChromium()) {
        var version = getChromiumVersion();
        return !!version && version < 74;
    }
    return false;
};
export var isIOS = function () {
    return /iPhone|iPad/i.test(getUserAgent()) || isIpadPlatform();
};
//# sourceMappingURL=browsers.js.map